import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { livyJson } from 'src/lib/livyApi';
import { currentRole, isLivyAdmin } from './access';
const SHOWN = new Set(['user', 'assistant', 'rep', 'event']);

/** A backtest replay kept for reading (saas-mcp-service /replay keep): the proxy refuses to continue one. */
export const isReplayConversation = id => Boolean(id === null || id === void 0 ? void 0 : id.startsWith('replay_'));

/** Staff browse their company's conversations; everyone else sees only their own. */
const staff = () => isLivyAdmin(currentRole());
export async function listConversations() {
  const _await$livyJson = await livyJson(staff() ? '/logs/conversations' : '/history'),
    conversations = _await$livyJson.conversations;
  return conversations;
}

/**
 * Rebuilds a thread from the transcript tier. Ordered by the stored sequence key rather than by
 * timestamp, because two messages in the same turn can share a second and would otherwise swap.
 */
export async function loadConversation(id) {
  if (!staff()) {
    const _await$livyJson2 = await livyJson("/history/".concat(encodeURIComponent(id))),
      messages = _await$livyJson2.messages;
    return messages;
  }
  const _await$livyJson3 = await livyJson("/logs/conversations/".concat(id, "?transcript=true")),
    items = _await$livyJson3.items;
  return items.filter(r => r.tier === 'transcript' && SHOWN.has(String(r.role))).sort((a, b) => String(a.sk).localeCompare(String(b.sk)))
  // A live handoff's lines keep their key, as /history gives it, so a poll after resuming adds nothing twice.
  .map(r => {
    var _r$content, _r$name;
    return _objectSpread(_objectSpread({
      role: r.role,
      content: (_r$content = r.content) !== null && _r$content !== void 0 ? _r$content : ''
    }, r.role === 'rep' ? {
      name: (_r$name = r.name) !== null && _r$name !== void 0 ? _r$name : null
    } : {}), String(r.sk).includes('~') ? {
      id: r.sk
    } : {});
  });
}

/** A thread is named by its first question, which is what a person actually remembers it by. */
export const titleFor = (messages, fallback) => {
  var _messages$find;
  const first = (_messages$find = messages.find(m => m.role === 'user')) === null || _messages$find === void 0 || (_messages$find = _messages$find.content) === null || _messages$find === void 0 ? void 0 : _messages$find.trim();
  if (!first) return fallback;
  return first.length > 60 ? "".concat(first.slice(0, 57), "...") : first;
};